import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type PackagePricing } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: PackagePricing.Api.InitRequest
  ): Promise<HttpApiResponse<PackagePricing.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/packagePricing`, args)
};
